const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/plus/app-settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/plus/app-settings")({
  beforeLoad: ({
    context
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    if (!currentCommunity?.branded_app_feature_flag_enabled) {
      redirect({
        to: settingsNavPathV3.plans.brandedApps,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});